/**
 * FileField
 * ======================================
 * - preview files
 */

const ELEMENTS = ".js-FileField";
const PREVIEW_EL = ".field-file__preview";
const maxAllowedSize = 10 * 1024 * 1024; // 10 MB + sync with ajax/forms.php!
const fileTypes = [
  "image/jpeg",
  "image/png",
  "image/webp",
  "image/heif",
  "image/heic"
];

 class FileField {
   constructor() {
     this.elements = document.querySelectorAll(ELEMENTS);

     if (!this.elements) {
       return false;
     }

     this.elements.forEach((el) => {
       el.addEventListener("change", this.changeHandler);
     });
   }

   validFileType = (file) => {
    return fileTypes.includes(file.type);
  }

  validFileSize = (file) => {
    if(file.size > maxAllowedSize) {
      return false
    }

    return true
  }

  returnFileSize = (number) => {
    if(number < 1024) {
      return number + 'bytes';
    } else if(number >= 1024 && number < 1048576) {
      return (number/1024).toFixed(1) + 'KB';
    } else if(number >= 1048576) {
      return (number/1048576).toFixed(1) + 'MB';
    }
  }

   changeHandler = (e) => {
     const input = e.currentTarget;
     const parent = input.closest('.field-file');
     const preview = parent.querySelector(PREVIEW_EL)
     const curFiles = input.files;

      preview.innerHTML = '';

      if(curFiles.length === 0) {
        const para = document.createElement('p');
        // para.textContent = preview.getAtrribute('data-no-files')

        parent.classList.remove('is-files')
        preview.appendChild(para);
      } else {
        const list = document.createElement('ul');

        parent.classList.add('is-files')
        preview.appendChild(list);

        for(const file of curFiles) {
          const listItem = document.createElement('li');
          const para = document.createElement('p');

          if(this.validFileType(file) && this.validFileSize(file)) {
            // para.innerHTML = ` ${file.name} <span class="field-file__preview-filesize">(${this.returnFileSize(file.size)})</span>`;
            const image = document.createElement('img');
            image.src = URL.createObjectURL(file);

            listItem.appendChild(image);
            listItem.appendChild(para);
          } else {
            para.innerHTML = `<span class="field-file__preview-error">Soubor ${file.name}: Nemá správný formát nebo je příliš veliký (max. 10MB). Vyberte jiný soubor.</span>`;
            listItem.appendChild(para);
          }

          list.appendChild(listItem);
        }
      }

   };
 }

 new FileField();
